import GridPageAbstract from '../../abstract/GridPageAbstract';
// component
import { MenuItem } from '@mui/material';
import i18n from '../../../i18n';
import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { approvalStates, processingStates } from '../statuses';
import ConfirmDialog from '../../dialogs/ConfirmDialog';
import { formatError } from '../../../utils/formatError';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class MerchantTerminalPayoutRequestsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'publicMerchantTerminalPayoutRequests';
        this.Server =
            this.props.context.getState().server.publicMerchantTerminalPayoutRequests;
        this.MenuDisplayType = 'menu';
        this.searchFields = [
            'requestedUser.firstName',
            'requestedUser.lastName',
            'merchantTerminal.name'
        ];
        this.exportButton = true;

        const defaultHead = [
            {
                id: 'merchantTerminalId',
                label: 'merchantTerminal',
                alignRight: false,
                cell: 'Select',
                show: 'name+merchantTerminalUuid',
                object: 'merchantTerminal',
                from: 'publicMerchantTerminals',
                displayGrid: true
            },
            {
                id: 'cryptoTokenId',
                label: 'cryptoToken',
                alignRight: false,
                cell: 'Select',
                show: 'coin',
                object: 'cryptoToken',
                from: 'cryptoCoins',
                displayGrid: true
            },
            {
                id: 'externalTransactionId',
                label: 'externalTransaction',
                object: 'externalTransaction',
                from: 'accountingExternalTransactions',
                alignRight: false,
                cell: 'Select',
                show: 'merchantAmount',
                displayGrid: true
            },
            {
                id: 'approvalState',
                label: 'approvalState',
                alignRight: false,
                cell: 'Items',
                items: Object.keys(approvalStates),
                displayGrid: true,
                disableEditor: true
            },
            {
                id: 'approvedUser',
                label: 'approvedUser',
                alignRight: false,
                cell: 'Select',
                show: 'firstName+lastName',
                object: 'approvedUser',
                from: 'users',
                displayGrid: true,
                disableEditor: true,
                customSort: 'approvedUser.firstName'
            },
            {
                id: 'payoutMethod',
                label: 'payoutMethod',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'processingState',
                label: 'processingState',
                alignRight: false,
                cell: 'Items',
                items: Object.keys(processingStates),
                displayGrid: true
            },
            {
                id: 'amount',
                label: 'amount',
                alignRight: false,
                cell: 'Amount',
                displayGrid: true
            },
            {
                id: 'credentials',
                label: 'credentials',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'note',
                label: 'note',
                alignRight: false,
                cell: 'Text',
                displayGrid: true
            },
            {
                id: 'processingDate',
                label: 'processingDate',
                alignRight: false,
                cell: 'Date',
                disableEditor: true,
                displayGrid: true
            }
        ];

        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head,
            confirmDialogOpen: false,
            confirmTargetId: null,
            confirmTargetStatus: null,
            confirmationText: '',
            errorText: ''
        };
    }

    openStatusConfirmDialog = (status, id) => {
        const actionText =
            status === 'approved'
                ? i18n.t('common.approve')
                : i18n.t('common.reject');
        this.setState({
            confirmDialogOpen: true,
            confirmTargetId: id,
            confirmTargetStatus: status,
            confirmationText: i18n.t('dialogs.confirmChangeStatus', {
                action: actionText
            }),
            errorText: '',
        });
        this.handleCloseMenu();
    };

    handleConfirmChangeStatus = () => {
        const { confirmTargetId, confirmTargetStatus } = this.state;
        this.Server.updateStatus(confirmTargetId, confirmTargetStatus).then(
            (res) => {
                if (res.error === 'OK') {
                    this.retrieveData();
                    this.setState({
                        confirmDialogOpen: false,
                        confirmTargetId: null,
                        confirmTargetStatus: null,
                        confirmationText: '',
                        errorText: ''
                    });
                } else {
                    const errorText = formatError(res);
                    this.setState({
                        errorText,
                        confirmationText: ''
                    });
                }
            }
        );
    };

    isShowActions = (permission, id) => {
        const isPending =
            this.List.find((item) => item.id === id)?.approvalState ===
            'pending';
        return isPending && this.allowedAction(permission);
    };

    renderConfirmDialog() {
        return (
            <ConfirmDialog
                dialogOpen={this.state.confirmDialogOpen}
                onConfirm={this.handleConfirmChangeStatus}
                onCancel={() => {
                    this.handleCloseMenu();
                    this.setState({
                        confirmDialogOpen: false,
                        confirmTargetId: null,
                        confirmTargetStatus: null,
                        confirmationText: '',
                        errorText: ''
                    });
                }}
                error={!!this.state.errorText}
                errorText={this.state.errorText}
                alertText={this.state.confirmationText}
                alertTitle={i18n.t('dialogs.confirmationTitle')}
            />
        );
    }

    renderCustomMenuItems(id) {
        const isShowActions = this.isShowActions(
            'change-payout-request-state',
            id
        );
        if (!isShowActions) return null;
        return [
            <MenuItem
                key="approve"
                sx={{
                    color: 'success.main'
                }}
                onClick={() => this.openStatusConfirmDialog('approved', id)}
            >
                <CheckIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.approve')}
            </MenuItem>,
            <MenuItem
                key="rejected"
                sx={{
                    color: 'error.main'
                }}
                onClick={() => this.openStatusConfirmDialog('rejected', id)}
            >
                <CloseIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.reject')}
            </MenuItem>
        ];
    }
}
